// Ilustraciones SVG originales de la plantilla infantil.
// Usan las variables del tema (currentColor / var(--ki-*)) para coordinarse
// con cada paleta. No representan personajes comerciales.

export function Banderines() {
  const colores = ["var(--ki-primario)", "var(--ki-acento)", "var(--ki-terciario)"];
  const ancho = 60;
  const total = 24;
  return (
    <svg className="ki-banderines" viewBox={`0 0 ${ancho * total} 72`} preserveAspectRatio="none" aria-hidden="true">
      <line x1="0" y1="4" x2={ancho * total} y2="4" stroke="var(--ki-texto)" strokeWidth="2.5" strokeLinecap="round" />
      {Array.from({ length: total }, (_, i) => (
        <polygon
          key={i}
          points={`${i * ancho + 6},6 ${(i + 1) * ancho - 6},6 ${i * ancho + ancho / 2},62`}
          fill={colores[i % colores.length]}
        />
      ))}
    </svg>
  );
}

const PIEZAS = [
  { left: "6%", top: "18%", color: "var(--ki-acento)", forma: "circulo", d: 0, dur: 7 },
  { left: "14%", top: "62%", color: "var(--ki-primario)", forma: "rect", d: 1.2, dur: 9 },
  { left: "22%", top: "34%", color: "var(--ki-terciario)", forma: "circulo", d: 2.1, dur: 8 },
  { left: "78%", top: "16%", color: "var(--ki-primario)", forma: "rect", d: 0.6, dur: 10 },
  { left: "88%", top: "46%", color: "var(--ki-acento)", forma: "circulo", d: 1.7, dur: 7.5 },
  { left: "70%", top: "70%", color: "var(--ki-terciario)", forma: "rect", d: 2.8, dur: 9.5 },
  { left: "40%", top: "10%", color: "var(--ki-terciario)", forma: "circulo", d: 0.3, dur: 8.5 },
  { left: "56%", top: "80%", color: "var(--ki-acento)", forma: "rect", d: 1.9, dur: 7 },
  { left: "94%", top: "78%", color: "var(--ki-primario)", forma: "circulo", d: 2.4, dur: 10 },
  { left: "4%", top: "82%", color: "var(--ki-terciario)", forma: "rect", d: 3.1, dur: 8 },
];

export function Confeti() {
  return (
    <div className="ki-confeti" aria-hidden="true">
      {PIEZAS.map((p, i) => (
        <span
          key={i}
          className={`ki-confeti-pieza ki-confeti-pieza--${p.forma}`}
          style={{
            left: p.left,
            top: p.top,
            background: p.color,
            animationDelay: `${p.d}s`,
            animationDuration: `${p.dur}s`,
          }}
        />
      ))}
    </div>
  );
}

export function Globos() {
  return (
    <svg className="ki-globos" viewBox="0 0 200 260" aria-hidden="true">
      <g className="ki-globo ki-globo--1">
        <path d="M60 118 Q40 160 66 210" fill="none" stroke="var(--ki-texto)" strokeWidth="2" />
        <ellipse cx="60" cy="78" rx="34" ry="42" fill="var(--ki-primario)" />
        <polygon points="54,116 66,116 60,128" fill="var(--ki-primario)" />
      </g>
      <g className="ki-globo ki-globo--2">
        <path d="M120 108 Q140 155 110 210" fill="none" stroke="var(--ki-texto)" strokeWidth="2" />
        <ellipse cx="122" cy="66" rx="30" ry="38" fill="var(--ki-acento)" />
        <polygon points="116,102 128,102 122,113" fill="var(--ki-acento)" />
      </g>
      <g className="ki-globo ki-globo--3">
        <path d="M165 140 Q185 175 150 215" fill="none" stroke="var(--ki-texto)" strokeWidth="2" />
        <ellipse cx="164" cy="104" rx="26" ry="33" fill="var(--ki-terciario)" />
        <polygon points="158,133 170,133 164,144" fill="var(--ki-terciario)" />
      </g>
    </svg>
  );
}
